// @flow
const initialState = {
  email: ''
};
export default initialState;